import React from 'react'
import { Link } from 'react-router-dom'
import { Stack } from '@mui/system'
import './css/style.css'
export default function Navbar() {
  return (
    <Stack direction="row" justifyContent="space-around" sx={{gap:{sm:'122px',xs:'40px'},mt:{sm:'32px',xs:'20px'}}}>
      <Link to="/" style={{textDecoration:'none'}}>
        <h1>GetFit</h1>
        </Link>
        <Stack direction="row" gap="40px" fontSize="24px" alignItems="flex-end">
          <Link to="/" style={{textDecoration:'none', color:'#3A1212',borderBottom:'3px solid #ff2625'}}>
          Home
          </Link>
          <a href="exercises" style={{textDecoration:'none',color:'#3A1212'}}>Exercises</a>
        </Stack>
    </Stack>
  )
}
